import type { useSnackbar } from 'notistack';

import type { SaveValidationErrorResponse } from './types';

export function normalizeRichTextValue(value?: string | null) {
  return (value ?? '').replace(/\r\n/g, '\n').trim();
}

export {
  AI_REVIEW_SUMMARY_MAX_LENGTH,
  toAiReviewSummaryFormValue,
  toAiReviewSummaryPayload,
} from '~/components/Common/Forms/OfferForm/aiReviewSummary';

export function resolveOfferLocationValue(offerLocation?: string | null, propertyName?: string | null) {
  if (offerLocation && offerLocation.toLowerCase() !== 'x') {
    return offerLocation;
  }

  return propertyName ?? '';
}

export function getApprovedSaveStatus(status: string) {
  return !status || status === 'draft' ? 'content-approved' : status;
}

const SLUG_PATTERN = /^[a-z0-9-]+$/;

export function isValidSlug(slug: string) {
  return SLUG_PATTERN.test(slug);
}

export function hasSaveValidationErrors(error: unknown): error is SaveValidationErrorResponse {
  if (!error || typeof error !== 'object' || !('errors' in error)) {
    return false;
  }

  const validationErrors = (error as { errors?: unknown }).errors;
  return Array.isArray(validationErrors);
}

export function showSaveError(error: unknown, enqueueSnackbar: ReturnType<typeof useSnackbar>['enqueueSnackbar']) {
  if (hasSaveValidationErrors(error)) {
    error.errors.forEach((validationError) => {
      enqueueSnackbar(validationError?.message ?? 'Validation error', { variant: 'error' });
    });
    return;
  }

  enqueueSnackbar(error instanceof Error ? error.message : 'Failed to save offer content', { variant: 'error' });
}
